import { render, staticRenderFns } from "./FeedImage.vue?vue&type=template&id=f49edf7e&"
import script from "./FeedImage.vue?vue&type=script&lang=js&"
export * from "./FeedImage.vue?vue&type=script&lang=js&"
import style0 from "./FeedImage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports